// extracted by mini-css-extract-plugin
export var background = "Hero-module--background--01320";
export var desktopImage = "Hero-module--desktopImage--84d0f";
export var doubleTextBlock = "Hero-module--doubleTextBlock--041ca";
export var hero = "Hero-module--hero--e76bd";
export var inverted = "Hero-module--inverted--b09f3";
export var label = "Hero-module--label--e87d0";
export var mobileImage = "Hero-module--mobileImage--745bf";
export var noDesktopImage = "Hero-module--noDesktopImage--8dc0f";
export var noMobileImage = "Hero-module--noMobileImage--58bcb";
export var overlay = "Hero-module--overlay--92431";
export var ratio_5_7 = "Hero-module--ratio_5_7--55717";